export function stylingDirective(
  node: Node,
  { expression: classes, modifiers, original }: any,
  { Alpine, cleanup }: any
) {
  // need to to this rather than use value since BEM modifiers can be complex
  // cnc-test__highlighted for example would be seen as cnc-test by Alpine
  const targetClass = original.split(/[:.]/g)[1]

  if (node.nodeType !== Node.ELEMENT_NODE) return
  if (!targetClass) return
  const classesRegex = new RegExp('\\b' + classes + '\\b')

  const el = node as HTMLElement

  let overridingParent = el.parentElement
  while (overridingParent) {
    const overrideAttrib = Array.from(overridingParent.attributes).some((attr) => {
      if (attr.name.startsWith('x-styling:')) {
        const [left] = attr.name.split('.')
        if (left === `x-styling:${targetClass}`) {
          return true
        }
      }
      return false
    })
    if (overrideAttrib) {
      break
    }
    overridingParent = overridingParent.parentElement
  }

  // this x-styling has been overriden
  if (overridingParent) {
    return
  }

  const styledEls = new Set<HTMLElement>()

  function applyStyles() {
    const oldStyledEls = new Set<HTMLElement>(styledEls)

    // track what elements have been styled
    for (const targetEl of Array.from(el.querySelectorAll(`.${targetClass}`)) as HTMLElement[]) {
      if (!styledEls.has(targetEl)) {
        styledEls.add(targetEl)
        // first time styling this element, so extract its unstyled classes
        // @ts-ignore
        if (targetEl?._x_undoAddedClasses) {
          // @ts-ignore
          targetEl?._x_undoAddedClasses()
          targetEl.setAttribute('data-old-classes', targetEl.className)
          rebindClasses(targetEl)
        } else {
          // @ts-ignore
          targetEl.setAttribute('data-old-classes', targetEl.className)
        }
      }
      oldStyledEls.delete(targetEl)
      // if the classes have already been applied, do nothing
      if (classesRegex.test(targetEl.className)) {
        continue
      }

      // needs to be applied to target
      if (modifiers.includes('replace')) {
        targetEl.className = targetClass + ' ' + classes
      } else if (modifiers.includes('prepend')) {
        targetEl.className = classes + ' ' + targetEl.className
      } /* is append or default */ else {
        // default is to append
        targetEl.className = targetEl.className + ' ' + classes
      }
    }

    for (const oldEl of oldStyledEls) {
      styledEls.delete(oldEl)
      // @ts-ignore
      oldEl?._x_undoAddedClasses()
      oldEl.className = oldEl.dataset.oldClasses!
      rebindClasses(oldEl)
    }
  }

  function rebindClasses(targetEl: Element) {
    if (targetEl.hasAttribute(':class')) {
      targetEl.setAttribute(':class', targetEl.getAttribute(':class')!)
    } else if (targetEl.hasAttribute('x-bind:class')) {
      targetEl.setAttribute('x-bind:class', targetEl.getAttribute('x-bind:class')!)
    }
  }
  Alpine.nextTick(applyStyles)

  const watcher = new MutationObserver(applyStyles)

  watcher.observe(el, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true,
    childList: true
  })

  cleanup(() => watcher.disconnect())
}
